import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { AppControllerService } from "../../../app-controller.service";
import { AlertType } from "../../models/alert";
import { debounceTime, take } from "rxjs/operators";
import { ApiWorkflowConstants } from "../../constants/api-constants/api-workflow.constants";
import { ApiNotesConstants } from "../../constants/api-constants/api-notes.constants";
let WorkflowJobService = class WorkflowJobService {
    http;
    appController;
    sessionNotes = [];
    currentStepComponent;
    jobCurrentStepId = null;
    createTriggeredSubject = new BehaviorSubject([]);
    $createTriggeredSteps = this.createTriggeredSubject.asObservable();
    jobCurrentStepsSubject = new BehaviorSubject([]);
    $jobCurrentSteps = this.jobCurrentStepsSubject.asObservable();
    jobCurrentStepSubject = new BehaviorSubject(null);
    $jobCurrentStep = this.jobCurrentStepSubject.asObservable();
    jobAutoLoadNextStepSubject = new BehaviorSubject(false);
    $jobAutoLoadNextStep = this.jobAutoLoadNextStepSubject.asObservable();
    showStepSaveSubject = new BehaviorSubject(true);
    $showStepSave = this.showStepSaveSubject.asObservable();
    showStepContinueSubject = new BehaviorSubject(true);
    $showStepContinue = this.showStepContinueSubject.asObservable();
    stepLoadedSubject = new BehaviorSubject(false);
    $stepLoaded = this.stepLoadedSubject.asObservable();
    jobCurrentNotesSubject = new BehaviorSubject(null);
    $jobCurrentNotes = this.jobCurrentNotesSubject.asObservable();
    constructor(http, appController) {
        this.http = http;
        this.appController = appController;
    }
    getJobCurrentStep() {
        return this.jobCurrentStepSubject.value;
    }
    getJobCurrentSteps(jobId, moduleId, autoLoadStep = false) {
        const request = this.getJobCurrentStepsRequest(jobId, moduleId).pipe(take(1)).subscribe((jobCurrentSteps) => {
            jobCurrentSteps.forEach(item => {
                item.jobId = +jobId;
                item.moduleId = +moduleId;
            });
            this.jobAutoLoadNextStepSubject.next(autoLoadStep);
            this.setJobCurrentSteps(jobCurrentSteps);
        });
    }
    setJobCurrentStep(jobCurrentStep) {
        if (this.jobCurrentStepId !== undefined && this.jobCurrentStepId !== null && this.jobCurrentStepId === jobCurrentStep.id) {
            return;
        }
        this.jobCurrentStepId = jobCurrentStep.id;
        try {
            const metadata = JSON.parse(jobCurrentStep.stepMeta);
            jobCurrentStep.parsedStepMeta = metadata;
            // this.jobCurrentStepMetaSubject.next(metadata);
        }
        catch (e) {
            this.appController.showMessage("Metadata missing. Please contact your system administrator.", AlertType.Error);
        }
        this.jobCurrentStepSubject.next(jobCurrentStep);
        // this.jobNextStepsSubject.next(jobCurrentStep.destinationSteps);
    }
    getMoveToSteps(moduleId, jobId) {
        const params = {
            moduleId,
            jobId
        };
        return this.http.get(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_GET_ALL_MOVABLE_STEP_TYPES, { params });
    }
    setCurrentStepComponent($event) {
        this.currentStepComponent = $event;
    }
    setShowStepSave(disabled) {
        this.showStepSaveSubject.next(disabled);
    }
    setShowStepContinue(disabled) {
        this.showStepContinueSubject.next(disabled);
    }
    setLoadStep(loaded) {
        this.stepLoadedSubject.next(loaded);
    }
    getJobCurrentNotes(jobId) {
        const request = this.http.get(ApiNotesConstants.URL, {
            params: {
                $expand: `user, step`,
                $filter: `jobId eq ${jobId}`
            }
        });
        request.pipe(take(1)).subscribe((notes) => {
            this.jobCurrentNotesSubject.next(notes);
        });
    }
    addSessionNoteId(id) {
        this.sessionNotes.push(id);
    }
    getJobCurrentStepsRequest(jobId, moduleId) {
        return this.http.get(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_JOB_CURRENT_STEPS, {
            params: {
                jobId: jobId?.toString(),
                moduleId: moduleId?.toString()
            }
        }).pipe(debounceTime(400));
    }
    setJobCurrentSteps(jobCurrentSteps) {
        this.jobCurrentStepsSubject.next(jobCurrentSteps);
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: AppControllerService }
    ];
};
WorkflowJobService = __decorate([
    Injectable({
        providedIn: "root"
    })
], WorkflowJobService);
export { WorkflowJobService };
